import { Tag } from '@cian/components';
import * as React from 'react';

import { EMaxPrepay } from '../../../../json_query';
import { IMaxPrepayTag } from '../../../state/tags/definitions/max_prepay';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IMaxPrepayTagItemProps {
  tag: IMaxPrepayTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const maxPrepayMap = {
  [EMaxPrepay.Month]: 'не более месяца',
  [EMaxPrepay.TwoMonths]: 'не более 2 месяцев',
  [EMaxPrepay.ThreeMonths]: 'не более 3 месяцев',
};

export const MaxPrepayTagItem = ({ tag, onDeleteClick, withNewTag }: IMaxPrepayTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === EMaxPrepay.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Предоплата: {maxPrepayMap[tag.value]}
    </TagComponent>
  );
};
